module.exports = __webpack_public_path__ + "static/car-sharing-app-cover-647ac87af581ba805bd14e1b66d12e20.png";